module.exports = __webpack_public_path__ + "static/media/store_location_icon.1b5cfe20.svg";